import React, { useCallback } from 'react';
import ArrowIcon from 'reusable-components/icons/duotone/ArrowIcon';

import useNavButtonsDisabled from '../hooks/useNavButtonsDisabled';

const CSS = require('./CarouselButtons.module.scss');

interface CarouselButtonsProps {
  carouselRef: any;
  variant?: 'light' | 'dark';
}

const getLeftPosition = (listElement: HTMLElement) => {
  const listStyle = window.getComputedStyle(listElement);
  const element = listElement.children[0] as HTMLElement;
  const width = element.offsetWidth;
  const columnGap = parseFloat(listStyle.columnGap || '0');

  return width + columnGap;
};

function CarouselButtons({
  carouselRef,
  variant = 'dark',
}: CarouselButtonsProps) {
  const { prevButtonDisabled, nextButtonDisabled } =
    useNavButtonsDisabled(carouselRef);

  const onNext = useCallback(() => {
    if (!carouselRef.current) {
      return;
    }
    const newPos = getLeftPosition(carouselRef.current);

    if (carouselRef.current.scrollBy) {
      carouselRef.current.scrollBy({
        left: newPos,
        behavior: 'smooth',
      });
    } else {
      carouselRef.current.scrollLeft = carouselRef.current.scrollLeft + newPos;
    }
  }, [carouselRef]);

  const onPrevious = useCallback(() => {
    if (!carouselRef.current) {
      return;
    }
    const newPos = getLeftPosition(carouselRef.current);

    if (carouselRef.current.scrollBy) {
      carouselRef.current.scrollBy({
        left: -newPos,
        behavior: 'smooth',
      });
    } else {
      carouselRef.current.scrollLeft = carouselRef.current.scrollLeft - newPos;
    }
  }, [carouselRef]);

  if (prevButtonDisabled && nextButtonDisabled) {
    return null;
  }

  return (
    <fieldset
      aria-label="carousel buttons"
      className={CSS.ButtonContainer}
      aria-controls="carousel"
    >
      <button
        onClick={onPrevious}
        className={CSS.Button}
        disabled={prevButtonDisabled}
        value="previous"
        aria-label="previous"
      >
        <ArrowIcon
          size={16}
          direction="left"
          className={CSS.Icon}
          variant={variant === 'light' ? 'white' : 'black'}
        />
      </button>
      <button
        onClick={onNext}
        className={CSS.Button}
        disabled={nextButtonDisabled}
        value="next"
        aria-label="next"
      >
        <ArrowIcon
          size={16}
          direction="right"
          className={CSS.Icon}
          variant={variant === 'light' ? 'white' : 'black'}
        />
      </button>
    </fieldset>
  );
}

export default CarouselButtons;
